// @flow
import * as type from './action-types'

const initialState = {
	code: null,
	loading: false,
	showToastMessage: false,
	userInfo: {},
	IsAuthorised: false,
	isSafariAutoFillInfoVisible: false,
	isSignOutTrigger: false,
	featureFlag: false
}

const reducerCommon = (state = initialState, action) => {
	switch (action.type) {
	case type.SET_MESSAGE:
		return {
			...state,
			code: action.code,
			showToastMessage: action.flag,
			uuidNumber: action.uuidNumber
		}
	case type.SET_LOADER:
		return {
			...state,
			loading: action.flag
		}
	case type.SET_USERINFO:
		return {
			...state,
			userInfo: action.userInfo
		}
	case type.SET_AUTHORISED_FLAG:
		return {
			...state,
			IsAuthorised: action.flag
		}
	case type.IS_SAFARI_AUTOFILL_VISISBLE:
		return {
			...state,
			isSafariAutoFillInfoVisible: action.flag
		}
	case type.SET_FEATURE_FLAG:
		return {
			...state,
			featureFlag: action.flag
		}
	case type.SET_ENTITLEMENTINFO:
		return {
			...state,
			entitlementInfo: action.entitlementInfo
		}	
	case type.SIGN_OUT: {
		const { payload } = action;
		return {
		   ...state,
		   isSignOutTrigger: payload
		};
	 }
	default:
		return state
	}
}

export default reducerCommon
